import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { LibPipesModule } from '../pipes/pipes.module';
import { NotificationComponent } from './notification.component';
import { NotificationService } from './notification.service';

@NgModule({
    imports: [CommonModule, LibPipesModule, MatIconModule, MatSnackBarModule, MatButtonModule],
    declarations: [NotificationComponent],
})
export class LibNotificationModule {
    static forRoot(): ModuleWithProviders<LibNotificationModule> {
        return {
            ngModule: LibNotificationModule,
            providers: [NotificationService],
        };
    }
}
